// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"601":"96c40f68","952":"273b6a66"}[chunkId] + ".chunk.css";
};